import { useQuery } from "react-query";
import { PendidikanResponse } from "../../../../models/Pendidikan";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const allPendidikanKey = "all-pendidikan-key";

export async function allPendidikan(): Promise<PendidikanResponse[]> {
  const res = await ApiClient.get(`/AllPendidikanSelection`);
  return res.data;
}

export default function useFetchAllPendidikan() {
  return useQuery([allPendidikanKey], queryWrapper(allPendidikan));
}
